import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'
import { messageProvider } from '@/utils/MessageProvider'
import { ApiTaLi140 } from '~/endpoints/ApiTaLi140'

export interface StateIdToken {
  idToken: string
  statusCode: number
  error: {
    messageId: string
    message: string
  } | null
}

export const getEmptyStateIdToken = (): StateIdToken => ({
  idToken: '',
  statusCode: 0,
  error: null,
})

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/IdToken',
})
export default class IdToken extends VuexModule {
  private state_: StateIdToken = getEmptyStateIdToken()

  get result(): StateIdToken {
    return this.state_
  }

  @Mutation
  updateIdToken(value: StateIdToken) {
    this.state_ = value
  }

  static readonly MUTATION_NAME_UPDATE_STATE = 'updateIdToken'

  @Action
  clear() {
    this.context.commit(IdToken.MUTATION_NAME_UPDATE_STATE, getEmptyStateIdToken())
  }

  @Action
  async getIdToken() {
    logger.trace('in: getIdToken')
    const api = new ApiTaLi140.Api()

    const result = await api.get<StateIdToken>(
      {},
      (data, status) => {
        return {
          idToken: data.id_token,
          statusCode: status,
          error: null,
        }
      },
      (data, status) => {
        return {
          idToken: getEmptyStateIdToken().idToken,
          statusCode: status,
          error: {
            messageId: data.error.messageId,
            message: data.error.message,
          },
        }
      }
    )

    const commitdata: StateIdToken = getEmptyStateIdToken()
    if (result) {
      commitdata.statusCode = result.statusCode
      commitdata.error = result.error
      if (commitdata.error === null) {
        commitdata.idToken = result.idToken
      }
    } else {
      const msgId = 'MSG-00-00023-E'
      commitdata.error = {
        messageId: msgId,
        message: messageProvider.get(msgId),
      }
    }
    this.context.commit(IdToken.MUTATION_NAME_UPDATE_STATE, commitdata)
  }
}
